class GridSize {
  static small = 600;
  static medium = 768
  static large = 992;
}

export default GridSize;